import { SVGProps, useId } from 'react';

const EnercityAppIcon = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${id}a)`}>
        <path
          fill="#F4F6FA"
          d="M205.743.425H50.26C22.737.425.426 22.736.426 50.259v155.483c0 27.523 22.311 49.834 49.834 49.834h155.483c27.523 0 49.834-22.311 49.834-49.834V50.259c0-27.523-22.311-49.834-49.834-49.834Z"
        />
        <path
          fill={`url(#${id}b)`}
          fillRule="evenodd"
          d="M129.545 201.505c-39.761 0-70.068-31.041-70.068-73.613 0-42.26 30.307-73.647 70.068-73.647 45.045 0 66.976 33.486 66.976 73.647 0 2.234-.255 6.679-.466 10.354-.06 1.023-.115 1.988-.16 2.827H93.885c2.932 17.35 17.899 30.192 35.66 30.595 15.537 0 32.532-8.501 40.317-21.475l24.609 20.064c-16.267 20.305-35.035 31.248-64.926 31.248Zm.07-117.595c19.046 0 31.732 11.15 32.949 31.421H93.885c3.476-18.653 16.996-31.42 35.66-31.42h.07Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          id={`${id}b`}
          x1={59.477}
          x2={196.521}
          y1={127.875}
          y2={127.875}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#909" />
          <stop offset={1} stopColor="red" />
        </linearGradient>
        <clipPath id={`${id}a`}>
          <path fill="#fff" d="M0 0h256v256H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnercityAppIcon;
